<script setup>
import { ref, computed, watch, nextTick, provide } from 'vue';

const { objet, fonctionValidationSaisie } = defineProps({
    objet: Object,
    fonctionValidationSaisie: Function
});

const emit = defineEmits(['validation']);

const verifErreursSaisie = ref(false);

const erreursSaisie = computed(() => {
    if (!verifErreursSaisie.value) {
        return {};
    }
    return fonctionValidationSaisie(objet);
});

watch(() => objet.validationFormulaire, (validation) => {
    if (validation) {
        delete objet.validationFormulaire;
        valider();
    }
});

function valider() {
    verifErreursSaisie.value = true;
    nextTick(() => {
        if (!Object.keys(erreursSaisie.value).map(cle => erreursSaisie.value[cle]).some(erreur => erreur !== null)) {
            emit('validation', objet);
        }
    });
}

provide('objet', objet);
provide('erreursSaisie', erreursSaisie);

</script>

<template>
    <div class="formulaire"
        @keydown.enter.prevent="valider()">
        <slot />
    </div>
</template>

<style scoped>

.formulaire {
	display: grid;
	grid-template-columns: auto auto;
	gap: 2px;
	align-items: start;
    min-width: 20vw;
    margin-top: 2px;
}

</style>